import React from "react";
import {connect} from "react-redux";

class fileLinkComponent extends React.Component {
    constructor(props) {
        super ( props );
        this.state = {
            lang : this.props.lang ,

        };

    }

    render() {
        return (

            <a href={this.props.link}>
                <img src={require ( "../images/pdf.png" )} alt={"..."}/>{this.props.text}
            </a>
        )
    }
}

const mapStateToProps = (state) => {
    return ({
        lang : state ? state.lang : '' ,
    });
};

export const FileLink = connect ( mapStateToProps ) ( fileLinkComponent );